/*
 * App Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

import {

  LOAD_INVOICES_ACTION,
  LOAD_INVOICES_SUCCESS_ACTION,
  LOAD_INVOICES_FAILURE_ACTION,

  UPDATE_USER_ACTION,

  SYNC_WORKFLOWS,
  SAVE_WORKFLOW,
  SAVE_WORKFLOW_SUCCESS,
  SAVE_WORKFLOW_FAILURE,
  FETCH_WORKFLOWS,
  FETCH_WORKFLOWS_SUCCESS,
  FETCH_WORKFLOWS_FAILURE,

  /**
   * CUSTOMERS
  */
  LOAD_CUSTOMER_ACTION,
  LOAD_CUSTOMER_SUCCESS_ACTION,
  LOAD_CUSTOMER_FAILURE_ACTION,

  CREATE_CUSTOMER_ACTION,
  CREATE_CUSTOMER_SUCCESS_ACTION,
  CREATE_CUSTOMER_FAILURE_ACTION,

  UPDATE_CUSTOMER_ACTION,
  UPDATE_CUSTOMER_SUCCESS_ACTION,
  UPDATE_CUSTOMER_FAILURE_ACTION,

  DELETE_CUSTOMER_ACTION,
  DELETE_CUSTOMER_SUCCESS_ACTION,
  DELETE_CUSTOMER_FAILURE_ACTION,

  LOAD_CUSTOMERS_ACTION,
  LOAD_CUSTOMERS_SUCCESS_ACTION,
  LOAD_CUSTOMERS_FAILURE_ACTION,

  DELETE_WORKFLOW,
  DELETE_WORKFLOW_SUCCESS,
  DELETE_WORKFLOW_FAILURE,

  /**
   * COMPANY
   */
  LOAD_COMPANY_ACTION,
  LOAD_COMPANY_SUCCESS_ACTION,
  LOAD_COMPANY_FAILURE_ACTION,

  LOAD_COMPANY_PLAN_ACTION,
  LOAD_COMPANY_PLAN_SUCCESS_ACTION,
  LOAD_COMPANY_PLAN_FAILURE_ACTION,

  CREATE_COMPANY_ACTION,
  CREATE_COMPANY_SUCCESS_ACTION,
  CREATE_COMPANY_FAILURE_ACTION,

  UPDATE_COMPANY_ACTION,
  UPDATE_COMPANY_SUCCESS_ACTION,
  UPDATE_COMPANY_FAILURE_ACTION,

  /**
   * PLAN
   */
  UPDATE_PLAN_ACTION,
  UPDATE_PLAN_SUCCESS_ACTION,
  UPDATE_PLAN_FAILURE_ACTION,

  LOAD_PROFILE_SUCCESS_ACTION,
  LOAD_USER_PROFILE,

  AUTH_USER_SET_SUCCESS,
  AUTH_USER_SET,
  DOCKET_SHOP_VALIDATION_FAILURE,

  SIGN_OUT,

  SUBSCRIBE_ACTION,
  SUBSCRIBE_SUCCESS_ACTION,
  SUBSCRIBE_FAILURE_ACTION,

  STRIPE_CONNECT_ACTION,
  STRIPE_CONNECT_SUCCESS_ACTION,
  STRIPE_CONNECT_FAILURE_ACTION,

  LOAD_CC_GATEWAY_ACTION,
  LOAD_CC_GATEWAY_SUCCESS_ACTION,
  LOAD_CC_GATEWAY_FAILURE_ACTION,

  LOAD_PAYMENTS,

  /**
   *  DOCUMENT
   */
  CREATE_DOCUMENT_ACTION,
  CREATE_DOCUMENT_SUCCESS_ACTION,
  CREATE_DOCUMENT_FAILURE_ACTION,

  UPDATE_DOCUMENT_ACTION,
  UPDATE_DOCUMENT_SUCCESS_ACTION,
  UPDATE_DOCUMENT_FAILURE_ACTION,

  DELETE_DOCUMENT_ACTION,
  DELETE_DOCUMENT_SUCCESS_ACTION,
  DELETE_DOCUMENT_FAILURE_ACTION,

  LOAD_DOCUMENTS_ACTION,

  /**
  *  DOCUMENT INSTANCES
  */
  CREATE_DOCUMENT_INSTANCE_ACTION,
  CREATE_DOCUMENT_INSTANCE_SUCCESS_ACTION,
  CREATE_DOCUMENT_INSTANCE_FAILURE_ACTION,

  UPDATE_DOCUMENT_INSTANCE_ACTION,
  UPDATE_DOCUMENT_INSTANCE_SUCCESS_ACTION,
  UPDATE_DOCUMENT_INSTANCE_FAILURE_ACTION,

  DELETE_DOCUMENT_INSTANCE_ACTION,
  DELETE_DOCUMENT_INSTANCE_SUCCESS_ACTION,
  DELETE_DOCUMENT_INSTANCE_FAILURE_ACTION,

  SHARE_DOCUMENT_INSTANCE_ACTION,

  LOAD_DOCUMENT_INSTANCES_ACTION,

  UPDATE_USER_CONFIGS,
  LOAD_USER_CONFIGS,
  LOAD_USER_CONFIGS_SUCCESS,
  UPDATE_USER_CONFIGS_SUCCESS,

  LOAD_INTEGRATIONS_ACTION,

  CREATE_INVOICE_SUCCESS_ACTION,
  UPDATE_INVOICE_SUCCESS_ACTION,
  LOAD_UNPAID_INVOICES_ACTION,

  LOAD_COMPANY_MEMBERS_ACTION,
  LOAD_COMPANY_MEMBERS_SUCCESS_ACTION,

  QB_SYNC_INVOICES_ACTION,
  QB_SYNC_CUSTOMERS_ACTION,

  DELETE_CART_CONFIGURATION,
  DELETE_CART_CONFIGURATION_SUCCESS,
  DELETE_CART_CONFIGURATION_FAILURE,
  SAVE_CART_CONFIGURATION,
  SAVE_CART_CONFIGURATION_SUCCESS,
  SAVE_CART_CONFIGURATION_FAILURE,
  FETCH_CART_CONFIGURATIONS,
  FETCH_CART_CONFIGURATIONS_SUCCESS,
  FETCH_CART_CONFIGURATIONS_FAILURE,
  SAVE_EMBED_CONFIGURATION,
  SAVE_EMBED_CONFIGURATION_SUCCESS,
  SAVE_EMBED_CONFIGURATION_FAILURE,
  FETCH_EMBED_CONFIGURATIONS,
  FETCH_EMBED_CONFIGURATIONS_SUCCESS,
  SYNC_EMBED_CONFIGURATIONS,
  SYNC_CART_CONFIGURATIONS,

  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,

  FETCH_API_KEYS,
  FETCH_API_KEYS_SUCCESS,
  SYNC_PRODUCTS,
  SYNC_VARIANTS,
  FETCH_VARIANTS,
  FETCH_VARIANTS_SUCCESS,
  FETCH_VARIANTS_FAILURE,
  SAVE_PRODUCT,
  SAVE_PRODUCT_SUCCESS,
  SAVE_PRODUCT_FAILURE,
  SAVE_VARIANT,
  SAVE_VARIANT_SUCCESS,
  SAVE_VARIANT_FAILURE,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  DELETE_VARIANT,
  DELETE_VARIANT_SUCCESS,
  DELETE_VARIANT_FAILURE,
  SYNC_CONNECTED_ACCOUNTS,
  SAVE_CONNECTED_ACCOUNT,
  SAVE_CONNECTED_ACCOUNT_SUCCESS,
  SAVE_CONNECTED_ACCOUNT_FAILURE,
  REMOVE_CONNECTED_ACCOUNT,
  REMOVE_CONNECTED_ACCOUNT_SUCCESS,
  REMOVE_CONNECTED_ACCOUNT_FAILURE,
  FETCH_CONNECTED_ACCOUNTS_SUCCESS,
  FETCH_CONNECTED_COMPANIES_SUCCESS,
  FETCH_CONNECTED_COMPANIES_FAILURE,
  FETCH_CONNECTED_COMPANIES,
  SYNC_DISCOUNTS,
  FETCH_DISCOUNTS,
  FETCH_DISCOUNTS_SUCCESS,
  FETCH_DISCOUNTS_FAILURE,
  SAVE_DISCOUNT,
  SAVE_DISCOUNT_SUCCESS,
  SAVE_DISCOUNT_FAILURE,
  DELETE_DISCOUNT,
  DELETE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_FAILURE,
  SET_MAX_DAILY_BOOKABLE_TASKS,
  QB_SYNC_FINSISHED_ACTION,
  LOAD_REFERRALS,
  LOAD_REFERRALS_SUCCESS,
  LOAD_REFERRALS_FAILURE,
  SYNC_INVOICE,
  SYNC_INVOICE_SUCCESS,
  SYNC_INVOICE_FAILURE,
} from './constants';

export function updateUser(user, cb) {
  return {
    type: UPDATE_USER_ACTION,
    user,
    cb
  }
}

export function fetchApiKeys(companyId) {
  return {
    type: FETCH_API_KEYS,
    companyId
  }
}

export function fetchApiKeysSuccess(apiMap) {
  return {
    type: FETCH_API_KEYS_SUCCESS,
    apiMap
  }
}

export function syncCartConfigurations(params) {
  return {
    type: SYNC_CART_CONFIGURATIONS,
    params
  }
}

export function fetchCartConfigurations(params) {
  return {
    type: FETCH_CART_CONFIGURATIONS
  }
}

export function fetchCartConfigurationsSuccess(cartConfigurations) {
  return {
    type: FETCH_CART_CONFIGURATIONS_SUCCESS,
    cartConfigurations
  }
}

export function fetchCartConfigurationsFailure(error) {
  return {
    type: FETCH_CART_CONFIGURATIONS_FAILURE,
    error
  }
}

export function saveCartConfiguration(params) {
  return {
    type: SAVE_CART_CONFIGURATION,
    params
  }
}

export function saveCartConfigurationSuccess(params) {
  return {
    type: SAVE_CART_CONFIGURATION_SUCCESS,
    params
  }
}

export function saveCartConfigurationFailure(error) {
  return {
    type: SAVE_CART_CONFIGURATION_FAILURE,
    error
  }
}

export function deleteCartConfiguration(params) {
  return {
    type: DELETE_CART_CONFIGURATION,
    params
  }
}

export function deleteCartConfigurationSuccess(params) {
  return {
    type: DELETE_CART_CONFIGURATION_SUCCESS,
    params
  }
}

export function deleteCartConfigurationFailure(error) {
  return {
    type: DELETE_CART_CONFIGURATION_FAILURE,
    error
  }
}

export function saveEmbedConfiguration(params) {
  return {
    type: SAVE_EMBED_CONFIGURATION,
    params
  }
}

export function saveEmbedConfigurationSuccess(params) {
  return {
    type: SAVE_EMBED_CONFIGURATION_SUCCESS,
    params
  }
}

export function saveEmbedConfigurationFailure(error) {
  return {
    type: SAVE_EMBED_CONFIGURATION_FAILURE,
    error
  }
}

export function deleteEmbedConfiguration(params) {
  return {
    type: DELETE_EMBED_CONFIGURATION,
    params
  }
}

export function deleteEmbedConfigurationSuccess(params) {
  return {
    type: DELETE_EMBED_CONFIGURATION_SUCCESS,
    params
  }
}

export function deleteEmbedConfigurationFailure(error) {
  return {
    type: DELETE_EMBED_CONFIGURATION_FAILURE,
    error
  }
}

export function syncEmbedConfigurations(params) {
  return {
    type: SYNC_EMBED_CONFIGURATIONS,
    params
  }
}

export function fetchEmbedConfigurations(params) {
  return {
    type: FETCH_EMBED_CONFIGURATIONS,
    params
  }
}

export function fetchEmbedConfigurationsSuccess(embedConfigurations) {
  return {
    type: FETCH_EMBED_CONFIGURATIONS_SUCCESS,
    embedConfigurations
  }
}

export function fetchEmbedConfigurationsFailure(error) {
  return {
    type: FETCH_EMBED_CONFIGURATIONS_FAILURE,
    error
  }
}

export function loadCompanyMembers() {
  return {
    type: LOAD_COMPANY_MEMBERS_ACTION,
  }
}

export function loadCompanyMembersSuccess(members) {
  return {
    type: LOAD_COMPANY_MEMBERS_SUCCESS_ACTION,
    members
  }
}

export function createInvoiceSuccess(invoice) {
  return {
    type: CREATE_INVOICE_SUCCESS_ACTION,
    invoice
  };
}

export function updateInvoiceSuccess(invoice) {
  return {
    type: UPDATE_INVOICE_SUCCESS_ACTION,
    invoice
  };
}

export function loadUnpaidInvoicesSuccess(invoices) {
  return {
    type: LOAD_UNPAID_INVOICES_ACTION,
    invoices
  };
}

export function updateUserConfigs(configs) {
  return {
    type: UPDATE_USER_CONFIGS,
    configs
  };
}
export function updateUserConfigsSuccess(configs) {
  return {
    type: UPDATE_USER_CONFIGS_SUCCESS,
    configs
  };
}
export function loadIntregrations(integrations) {
  return {
    type: LOAD_INTEGRATIONS_ACTION,
    integrations
  }
}
export function loadUserConfigs() {
  return {
    type: LOAD_USER_CONFIGS,
  }
}
export function loadPricingMatrices(pricingMatrices) {
  return {
    type: LOAD_PRICING_MATRICES,
    pricingMatrices
  }
}

export function updatePricingMatrix(matrix) {
  return {
    type: UPDATE_PRICING_MATRIX,
    matrix
  }
}

export function loadUserConfigsSuccess(configs) {
  return {
    type: LOAD_USER_CONFIGS_SUCCESS,
    configs
  }
}
export function addToHistory(route, name, description, date, type) {
  item = { route, name, description, date, type }
  return {
    type: ADD_TO_HISTORY_ACTION,
    item
  };
}
export function addToHistorySuccess(history) {
  return {
    type: ADD_TO_HISTORY_SUCCES_ACTION,
    history
  };
}
export function loadPayments(payments) {
  return {
    type: LOAD_PAYMENTS,
    payments
  };
}
export function markMesagesRead() {
  return {
    type: MARK_MESSAGES_READ,
  }
}

export function signOut() {
  return { type: SIGN_OUT }
}
export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function authUserSet(authUser) {
  return {
    type: AUTH_USER_SET,
    authUser
  };
}
export function authUserSuccess(authUser) {
  return {
    type: AUTH_USER_SET_SUCCESS,
    authUser
  };
}

export function docketShopValidationFailure(reason) {
  return {
    type: DOCKET_SHOP_VALIDATION_FAILURE,
    reason,
  };
}


export function loadUserProfile(profile) {
  return {
    type: LOAD_USER_PROFILE,
    profile
  };
}


export function loadProfileSuccess(userProfile) {
  return {
    type: LOAD_PROFILE_SUCCESS_ACTION,
    userProfile
  };
}

export function loadLinkedAccountsSuccess(linkedAccounts) {
  return {
    type: LOAD_LINKED_ACCOUNTS_SUCCESS_ACTION,
    linkedAccounts
  };
}

export function loadLinkedAccountSuccess(linkedAccount) {
  return {
    type: LOAD_LINKED_ACCOUNT_SUCCESS_ACTION,
    linkedAccount
  };
}

export function loadNonReviewedEstimatesSuccess(estimates) {
  return {
    type: LOAD_NON_REVIEWED_ESTIMATES_SUCCESS_ACTION,
    estimates
  };
}

export function loadEstimatesSuccess(estimates) {
  return {
    type: LOAD_ESTIMATES_SUCCESS_ACTION,
    estimates
  };
}
export function loadInvoicesSuccess(invoices) {
  return {
    type: LOAD_INVOICES_SUCCESS_ACTION,
    invoices
  };
}

export function loadUnassignedInvoicesSuccess(invoices) {
  return {
    type: LOAD_UNASSIGNED_INVOICES_SUCCESS_ACTION,
    invoices
  };
}

/**
 * PRODUCTS
 */

 export function syncProducts(params) {
  return {
    type: SYNC_PRODUCTS,
    params
  }
}

export function deleteProduct(params) {
  return {
    type: DELETE_PRODUCT,
    params
  }
}

export function deleteProductSuccess(params) {
  return {
    type: DELETE_PRODUCT_SUCCESS,
    params
  }
}

export function deleteProductFailure(error) {
  return {
    type: DELETE_PRODUCT_FAILURE,
    error
  }
}

export function fetchProducts(params) {
  return {
    type: FETCH_PRODUCTS,
    params
  }
}

export function fetchProductsSuccess(products) {
  return {
    type: FETCH_PRODUCTS_SUCCESS,
    products
  }
}

export function fetchProductsFailure(params) {
  return {
    type: FETCH_PRODUCTS_FAILURE,
    params
  }
}

export function syncVariants(params) {
  return {
    type: SYNC_VARIANTS,
    params
  }
}

export function fetchVariants(params) {
  return {
    type: FETCH_VARIANTS,
    params
  }
}

export function fetchVariantsSuccess(params) {
  return {
    type: FETCH_VARIANTS_SUCCESS,
    params
  }
}

export function fetchVariantsFailure(params) {
  return {
    type: FETCH_VARIANTS_FAILURE,
    params
  }
}

export function saveProduct(params) {
  return {
    type: SAVE_PRODUCT,
    params
  }
}

export function saveProductSuccess(params) {
  return {
    type: SAVE_PRODUCT_SUCCESS,
    params
  }
}

export function saveProductFailure(error) {
  return {
    type: SAVE_PRODUCT_FAILURE,
    error
  }
}

export function saveVariant(params) {
  return {
    type: SAVE_VARIANT,
    params
  }
}

export function saveVariantSuccess(params) {
  return {
    type: SAVE_VARIANT_SUCCESS,
    params
  }
}

export function saveVariantFailure(error) {
  return {
    type: SAVE_VARIANT_FAILURE,
    error
  }
}

export function syncDiscounts(params) {
  return {
    type: SYNC_DISCOUNTS,
    params
  }
}

export function fetchDiscounts(params) {
  return {
    type: FETCH_DISCOUNTS,
    params
  }
}

export function fetchDiscountsSuccess(discounts) {
  return {
    type: FETCH_DISCOUNTS_SUCCESS,
    discounts
  }
}

export function fetchDiscountsFailure(params) {
  return {
    type: FETCH_DISCOUNTS_FAILURE,
    params
  }
}

export function saveDiscount(params) {
  return {
    type: SAVE_DISCOUNT,
    params
  }
}

export function saveDiscountSuccess(params) {
  return {
    type: SAVE_DISCOUNT_SUCCESS,
    params
  }
}

export function saveDiscountFailure(error) {
  return {
    type: SAVE_DISCOUNT_FAILURE,
    error
  }
}

export function deleteDiscount(params) {
  return {
    type: DELETE_DISCOUNT,
    params
  }
}

export function deleteDiscountSuccess(params) {
  return {
    type: DELETE_DISCOUNT_SUCCESS,
    params
  }
}

export function deleteDiscountFailure(error) {
  return {
    type: DELETE_DISCOUNT_FAILULRE,
    error
  }
}

export function deleteVariant(params) {
  return {
    type: DELETE_VARIANT,
    params
  }
}

export function deleteVariantSuccess(params) {
  return {
    type: DELETE_VARIANT_SUCCESS,
    params
  }
}

export function deleteVariantFailure(error) {
  return {
    type: DELETE_VARIANT_FAILURE,
    error
  }
}




/**
 * CUSTOMERS
 */
export function loadCustomers() {
  return {
    type: LOAD_CUSTOMERS_ACTION,
  };
}
export function loadAdHocInvoice(invoice) {
  //entity type ie. customer, employee, invoice, estimnate, job
  let action =
  {
    type: LOAD_AD_HOC_INVOICE,
    invoice
  };
  return action
}

export function loadAdHocEntity(entityType, id) {
  //entity type ie. customer, employee, invoice, estimnate, job
  let action =
  {
    type: LOAD_AD_HOC_ENTITY,
    entityType,
    id
  };
  return action
}

export function loadAdHocEntitySuccess(entityType, entity) {
  //entity type ie. customer, employee, invoice, estimnate, job
  let action =
  {
    type: LOAD_AD_HOC_ENTITY_SUCCESS,
  };
  action[entityType] = entity
  return action
}



export function loadCustomersSuccess(customers) {
  if (customers === null) {
    customers = []
  }
  return {
    type: LOAD_CUSTOMERS_SUCCESS_ACTION,
    customers
  };
}

export function loadCustomersFailure(error) {
  return {
    type: LOAD_CUSTOMERS_FAILURE_ACTION,
    error
  };
}

export function createCustomer(customer, callback) {
  return {
    type: CREATE_CUSTOMER_ACTION,
    customer,
    callback
  };
}

export function createCustomerSuccess(customer) {
  return {
    type: CREATE_CUSTOMER_SUCCESS_ACTION,
    customer
  };
}

export function createCustomerFailure(error) {
  return {
    type: CREATE_CUSTOMER_FAILURE_ACTION,
    error
  };
}

export function updateCustomer(customer) {
  return {
    type: UPDATE_CUSTOMER_ACTION,
    customer
  };
}

export function updateCustomerSuccess(customer) {
  return {
    type: UPDATE_CUSTOMER_SUCCESS_ACTION,
    customer
  };
}

export function updateCustomerFailure(error) {
  return {
    type: UPDATE_CUSTOMER_FAILURE_ACTION,
    error
  };
}


/**
 * COMPANY
 */
export function loadCompany() {
  return {
    type: LOAD_COMPANY_ACTION,
  };
}

export function loadCompanySuccess(company, memberProfile) {
  return {
    type: LOAD_COMPANY_SUCCESS_ACTION,
    company,
    memberProfile
  };
}
export function loadCompanyPlanSuccess(plan) {
  return {
    type: LOAD_COMPANY_PLAN_SUCCESS_ACTION,
    plan
  };
}


export function loadCompanyFailure(error) {
  return {
    type: LOAD_COMPANY_FAILURE_ACTION,
    error
  };
}

export function createCompany(company) {
  return {
    type: CREATE_COMPANY_ACTION,
    company
  };
}

export function createCompanySuccess(company) {
  return {
    type: CREATE_COMPANY_SUCCESS_ACTION,
    company
  };
}

export function createCompanyFailure(error) {
  return {
    type: CREATE_COMPANY_FAILURE_ACTION,
    error
  };
}

export function updateCompany(company, memberProfile) {
  return {
    type: UPDATE_COMPANY_ACTION,
    company,
    memberProfile
  };
}

export function updateCompanySuccess(company) {
  return {
    type: UPDATE_COMPANY_SUCCESS_ACTION,
    company
  };
}

export function updateCompanyFailure(error) {
  return {
    type: UPDATE_COMPANY_FAILURE_ACTION,
    error
  };
}

/**
 * PLAN
 */
export function updatePlan(plan) {
  return {
    type: UPDATE_PLAN_ACTION,
    plan
  };
}

export function updatePlanSuccess(plan) {
  return {
    type: UPDATE_PLAN_SUCCESS_ACTION,
    plan
  };
}

export function updatePlanFailure(error) {
  return {
    type: UPDATE_PLAN_FAILURE_ACTION,
    error
  };
}

/**
 * JOB CATEGORIES
 */
export function loadJobCategories() {
  return {
    type: LOAD_JOB_CATEGORIES_ACTION,
  };
}

export function loadJobCategoriesSuccess(jobCategories) {
  return {
    type: LOAD_JOB_CATEGORIES_SUCCESS_ACTION,
    jobCategories
  };
}

export function loadJobCategoriesFailure(error) {
  return {
    type: LOAD_JOB_CATEGORIES_FAILURE_ACTION,
    error
  };
}


/**
 * JOB STATUSES
 */
export function loadJobStatuses() {
  return {
    type: LOAD_JOB_STATUSES_ACTION,
  };
}

export function loadJobStatusesSuccess(jobStatuses) {
  return {
    type: LOAD_JOB_STATUSES_SUCCESS_ACTION,
    jobStatuses
  };
}

export function loadJobStatusesFailure(error) {
  return {
    type: LOAD_JOB_STATUSES_FAILURE_ACTION,
    error
  };
}

/**
 * SUBSCRIBE
 */
export function subscribe(token, plan, amount, coupon) {
  return {
    type: SUBSCRIBE_ACTION,
    token,
    plan,
    amount,
    coupon,
  };
}

export function subscribeSuccess() {
  return {
    type: SUBSCRIBE_SUCCESS_ACTION,
  };
}

export function subscribeFailure(error) {
  return {
    type: SUBSCRIBE_FAILURE_ACTION,
    error,
  };
}

/**
 * STRIPE CONNECT
 */
export function stripeConnect(companyId, accountId) {
  return {
    type: STRIPE_CONNECT_ACTION,
    companyId,
    accountId
  };
}

export function stripeConnectSuccess() {
  return {
    type: STRIPE_CONNECT_SUCCESS_ACTION,

  };
}


export function stripeConnectFailure(error) {
  return {
    type: STRIPE_CONNECT_FAILURE_ACTION,

  };
}

export function loadccGateway(companyId) {
  return {
    type: LOAD_CC_GATEWAY_ACTION,
    companyId,
  };
}

export function loadccGatewaySuccess(ccGateway) {
  return {
    type: LOAD_CC_GATEWAY_SUCCESS_ACTION,
    ccGateway,
  };
}

export function loadccGatewayFailure(error) {
  return {
    type: LOAD_CC_GATEWAY_FAILURE_ACTION,
  };
}

export function loadMessages(messages) {
  return {
    type: LOAD_MESSAGES,
    messages
  };
}

export function loadLogs(logs) {
  return {
    type: LOAD_LOGS,
    logs
  };
}

export function addLog(log) {
  return {
    type: ADD_LOG,
    log
  };
}

export function deleteCustomer(customer) {
  return {
    type: DELETE_CUSTOMER_ACTION,
    customer
  };
}

export function loadEmployeeLocations(locations) {
  return {
    type: LOAD_EMPLOYEE_LOCATIONS_ACTION,
    locations
  };
}

export function loadEmployeeStatus(employeeStatus) {
  return {
    type: LOAD_EMPLOYEE_STATUS_ACTION,
    employeeStatus
  };
}

export function loadTimeEntries() {
  return {
    type: LOAD_TIME_ENTRIES_ACTION,
  };
}

export function loadTimeEntriesSuccess(timeEntries) {
  return {
    type: LOAD_TIME_ENTRIES_SUCCESS_ACTION,
    timeEntries
  };
}

export function loadAdhocCostSuccess(costs) {
  return {
    type: LOAD_COSTS_SUCCESS_ACTION,
    costs
  };
}



/**
 * CONTRACTORS
 */

export function loadContractors() {
  return {
    type: LOAD_CONTRACTORS_ACTION,
  };
}

export function loadContractorsSuccess(contractors) {
  if (contractors === null) {
    contractors = []
  }
  return {
    type: LOAD_CONTRACTORS_SUCCESS_ACTION,
    contractors
  };
}

export function loadContractorsFailure(error) {
  return {
    type: LOAD_CONTRACTORS_FAILURE_ACTION,
    error
  };
}

export function createContractor(contractor) {
  return {
    type: CREATE_CONTRACTOR_ACTION,
    contractor
  };
}

export function createContractorSuccess(contractor) {
  return {
    type: CREATE_CONTRACTOR_SUCCESS_ACTION,
    contractor
  };
}

export function createContractorFailure(error) {
  return {
    type: CREATE_CONTRACTOR_FAILURE_ACTION,
    error
  };
}

export function updateContractor(contractor) {
  return {
    type: UPDATE_CONTRACTOR_ACTION,
    contractor
  };
}

export function updateContractorSuccess(contractor) {
  return {
    type: UPDATE_CONTRACTOR_SUCCESS_ACTION,
    contractor
  };
}

export function updateContractorFailure(error) {
  return {
    type: UPDATE_CONTRACTOR_FAILURE_ACTION,
    error
  };
}

export function deleteContractor(contractor) {
  return {
    type: DELETE_CONTRACTOR_ACTION,
    contractor
  };
}

export function createNote(note, callback) {
  return {
    type: CREATE_NOTE_ACTION,
    note,
    callback
  };
}

export function createNoteSuccess(note) {
  return {
    type: CREATE_NOTE_SUCCESS_ACTION,
    note
  };
}

export function createNoteFailure(error) {
  return {
    type: CREATE_NOTE_FAILURE_ACTION,
    error
  };
}

export function deleteNote(note) {
  return {
    type: DELETE_NOTE_ACTION,
    note
  };
}

export function deleteNoteSuccess() {
  return {
    type: DELETE_NOTE_SUCCESS_ACTION,
  };
}

export function deleteNoteFailure(error) {
  return {
    type: DELETE_NOTE_FAILURE_ACTION,
    error
  };
}

export function updateNote(note) {
  return {
    type: UPDATE_NOTE_ACTION,
    note
  };
}

export function updateNoteSuccess(note) {
  return {
    type: UPDATE_NOTE_SUCCESS_ACTION,
    note
  };
}

export function updateNoteFailure(error) {
  return {
    type: UPDATE_NOTE_FAILURE_ACTION,
    error
  };
}

export function loadNotes(notes) {
  return {
    type: LOAD_NOTES_ACTION,
    notes
  };
}

export function createDocument(document, callback) {
  return {
    type: CREATE_DOCUMENT_ACTION,
    document,
    callback
  };
}

export function createDocumentSuccess(document) {
  return {
    type: CREATE_DOCUMENT_SUCCESS_ACTION,
    document
  };
}

export function createDocumentFailure(error) {
  return {
    type: CREATE_DOCUMENT_FAILURE_ACTION,
    error
  };
}

export function deleteDocument(document) {
  return {
    type: DELETE_DOCUMENT_ACTION,
    document
  };
}

export function deleteDocumentSuccess() {
  return {
    type: DELETE_DOCUMENT_SUCCESS_ACTION,
  };
}

export function deleteDocumentFailure(error) {
  return {
    type: DELETE_DOCUMENT_FAILURE_ACTION,
    error
  };
}

export function updateDocument(document) {
  return {
    type: UPDATE_DOCUMENT_ACTION,
    document
  };
}

export function updateDocumentSuccess(document) {
  return {
    type: UPDATE_DOCUMENT_SUCCESS_ACTION,
    document
  };
}

export function updateDocumentFailure(error) {
  return {
    type: UPDATE_DOCUMENT_FAILURE_ACTION,
    error
  };
}

export function loadDocuments(documents) {
  return {
    type: LOAD_DOCUMENTS_ACTION,
    documents
  };
}

export function createDocumentInstance(documentInstance, callback) {
  return {
    type: CREATE_DOCUMENT_INSTANCE_ACTION,
    documentInstance,
    callback
  };
}

export function createDocumentInstanceSuccess(documentInstance) {
  return {
    type: CREATE_DOCUMENT_INSTANCE_SUCCESS_ACTION,
    documentInstance
  };
}

export function createDocumentInstanceFailure(error) {
  return {
    type: CREATE_DOCUMENT_INSTANCE_FAILURE_ACTION,
    error
  };
}

export function deleteDocumentInstance(documentInstance) {
  return {
    type: DELETE_DOCUMENT_INSTANCE_ACTION,
    documentInstance
  };
}

export function deleteDocumentInstanceSuccess() {
  return {
    type: DELETE_DOCUMENT_INSTANCE_SUCCESS_ACTION,
  };
}

export function deleteDocumentInstanceFailure(error) {
  return {
    type: DELETE_DOCUMENT_INSTANCE_FAILURE_ACTION,
    error
  };
}

export function updateDocumentInstance(documentInstance) {
  return {
    type: UPDATE_DOCUMENT_INSTANCE_ACTION,
    documentInstance
  };
}

export function updateDocumentInstanceSuccess(documentInstance) {
  return {
    type: UPDATE_DOCUMENT_INSTANCE_SUCCESS_ACTION,
    documentInstance
  };
}

export function updateDocumentInstanceFailure(error) {
  return {
    type: UPDATE_DOCUMENT_INSTANCE_FAILURE_ACTION,
    error
  };
}

export function shareDocumentInstance(documentInstance) {
  return {
    type: SHARE_DOCUMENT_INSTANCE_ACTION,
    documentInstance
  };
}

export function loadDocumentInstances(documentInstances) {
  return {
    type: LOAD_DOCUMENT_INSTANCES_ACTION,
    documentInstances
  };
}

export function updateContainer(container) {
  return {
    type: UPDATE_CONTAINER_ACTION,
    container
  };
}

export function updateContainerSuccess(container) {
  return {
    type: UPDATE_CONTAINER_SUCCESS_ACTION,
    container
  };
}

export function updateContainerFailure(error) {
  return {
    type: UPDATE_CONTAINER_FAILURE_ACTION,
    error
  };
}

export function createTimecardEntry(timecardEntry) {
  return {
    type: CREATE_TIMECARD_ENTRY_ACTION,
    timecardEntry
  };
}

export function createTimecardEntrySuccess(timecardEntry) {
  return {
    type: CREATE_TIMECARD_ENTRY_SUCCESS_ACTION,
    timecardEntry
  };
}

export function createTimecardEntryFailure(error) {
  return {
    type: CREATE_TIMECARD_ENTRY_FAILURE_ACTION,
    error
  };
}

export function updateTimecardEntry(timecardEntry) {
  return {
    type: UPDATE_TIMECARD_ENTRY_ACTION,
    timecardEntry
  };
}

export function updateTimecardEntrySuccess(timecardEntry) {
  return {
    type: UPDATE_TIMECARD_ENTRY_SUCCESS_ACTION,
    timecardEntry
  };
}

export function updateTimecardEntryFailure(error) {
  return {
    type: UPDATE_TIMECARD_ENTRY_FAILURE_ACTION,
    error
  };
}

export function deleteTimecardEntry(timecardEntry) {
  return {
    type: DELETE_TIMECARD_ENTRY_ACTION,
    timecardEntry
  };
}

export function deleteTimecardEntrySuccess(timecardEntry) {
  return {
    type: DELETE_TIMECARD_ENTRY_SUCCESS_ACTION,
    timecardEntry
  };
}

export function deleteTimecardEntryFailure(error) {
  return {
    type: DELETE_TIMECARD_ENTRY_FAILURE_ACTION,
    error
  };
}

export function loadLocations() {
  return {
    type: LOAD_LOCATIONS_ACTION,
  };
}

export function loadConversationSuccess(conversations) {
  return {
    type: LOAD_CONVERSATIONS_SUCCESS_ACTION,
    conversations
  };
}
export function loadLocationsSuccess(locations) {
  return {
    type: LOAD_LOCATIONS_SUCCESS_ACTION,
    locations
  };
}

export function loadLocationsFailure(error) {
  return {
    type: LOAD_LOCATIONS_FAILURE_ACTION,
    error
  };
}

export function createLocation(location) {
  return {
    type: CREATE_LOCATION_ACTION,
    location
  };
}

export function loadSharedLocationSuccess(locations) {
  return {
    type: LOAD_SHARED_LOCATION_SUCCESS,
    locations
  };
}

export function createLocationSuccess(location) {
  return {
    type: CREATE_LOCATION_SUCCESS_ACTION,
    location
  };
}

export function createLocationFailure(error) {
  return {
    type: CREATE_LOCATION_FAILURE_ACTION,
    error
  };
}

export function updateLocation(location) {
  return {
    type: UPDATE_LOCATION_ACTION,
    location
  };
}

export function updateLocationSuccess(location) {
  return {
    type: UPDATE_LOCATION_SUCCESS_ACTION,
    location
  };
}

export function updateLocationFailure(error) {
  return {
    type: UPDATE_LOCATION_FAILURE_ACTION,
    error
  };
}

export function deleteLocation(location) {
  return {
    type: DELETE_LOCATION_ACTION,
    location
  };
}

export function deleteLocationSuccess(location) {
  return {
    type: DELETE_LOCATION_SUCCESS_ACTION,
    location
  };
}

export function deleteLocationFailure(error) {
  return {
    type: DELETE_LOCATION_FAILURE_ACTION,
    error
  };
}

export function QBSyncInvoices(invoices, customers) {
  return {
    type: QB_SYNC_INVOICES_ACTION,
    invoices,
    customers
  };
}
export function QBSyncCustomers(customers) {
  return {
    type: QB_SYNC_CUSTOMERS_ACTION,
    customers
  };
}

export function syncWorkflows(params) {
  return {
    type: SYNC_WORKFLOWS,
    params
  }
}

export function saveWorkflow(params) {
  return {
    type: SAVE_WORKFLOW,
    params
  }
}

export function saveWorkflowSuccess(params) {
  return {
    type: SAVE_WORKFLOW_SUCCESS,
    params
  }
}

export function saveWorkflowFailure(error) {
  return {
    type: SAVE_WORKFLOW_FAILURE,
    error
  }
}

export function deleteWorkflow(params) {
  return {
    type: DELETE_WORKFLOW,
    params
  }
}

export function deleteWorkflowSuccess(params) {
  return {
    type: DELETE_WORKFLOW_SUCCESS,
    params
  }
}

export function deleteWorkflowFailure(error) {
  return {
    type: DELETE_WORKFLOW_FAILURE,
    error
  }
}

export function fetchWorkflows(params) {
  return {
    type: FETCH_WORKFLOWS,
    params
  }
}

export function fetchWorkflowsSuccess(workflows) {
  return {
    type: FETCH_WORKFLOWS_SUCCESS,
    workflows
  }
}

export function fetchWorkflowsFailure(error) {
  return {
    type: FETCH_WORKFLOWS_FAILURE,
    error
  }
}

export function syncConnectedAccounts(params) {
  return {
    type: SYNC_CONNECTED_ACCOUNTS,
    params
  }
}

export function fetchConnectedCompanies(connectedCompanies) {
  return {
    type: FETCH_CONNECTED_COMPANIES,
    connectedCompanies
  }
}

export function fetchConnectedCompaniesSuccess(connectedCompanies) {
  return {
    type: FETCH_CONNECTED_COMPANIES_SUCCESS,
    connectedCompanies
  }
}

export function fetchConnectedCompaniesFailure(error) {
  return {
    type: FETCH_CONNECTED_COMPANIES_FAILURE,
    error
  }
}

export function fetchConnectedAccountsSuccess(connectedAccounts) {
  return {
    type: FETCH_CONNECTED_ACCOUNTS_SUCCESS,
    connectedAccounts
  }
}

export function fetchConnectedAccountsFailure(error) {
  return {
    type: FETCH_CONNECTED_ACCOUNTS_FAILURE,
    error
  }
}

export function saveConnectedAccount(params) {
  return {
    type: SAVE_CONNECTED_ACCOUNT,
    params
  }
}


export function saveConnectedAccountSuccess(account) {
  return {
    type: SAVE_CONNECTED_ACCOUNT_SUCCESS,
    account
  }
}

export function saveConnectedAccountFailure(params) {
  return {
    type: SAVE_CONNECTED_ACCOUNT_FAILURE,
    params
  }
}

export function removeConnectedAccount(account) {
  return {
    type: REMOVE_CONNECTED_ACCOUNT,
    account
  }
}

export function removeConnectedAccountSuccess(account) {
  return {
    type: REMOVE_CONNECTED_ACCOUNT_SUCCESS,
    account
  }
}

export function removeConnectedAccountFailure(account) {
  return {
    type: REMOVE_CONNECTED_ACCOUNT_Failure,
    account
  }
}

export const setMaxDailyBookableTasks = maxDailyBookable => ({
  type: SET_MAX_DAILY_BOOKABLE_TASKS,
  maxDailyBookable,
});

export function QBSyncFinished() {
  return {
    type: QB_SYNC_FINSISHED_ACTION,
  };
}

export function loadReferrals() {
  return {
    type: LOAD_REFERRALS,
  };
}

export function loadReferralsSuccess(referrals) {
  return {
    type: LOAD_REFERRALS_SUCCESS,
    referrals,
  };
}

export function loadReferralsFailure(error) {
  return {
    type: LOAD_REFERRALS_FAILURE,
    error,
  };
}

export function syncInvoice(params) {
  return {
    type: SYNC_INVOICE,
    params,
  };
}

export function syncInvoiceSuccess(invoice) {
  return {
    type: SYNC_INVOICE_SUCCESS,
    invoice,
  };
}

export function syncInvoiceFailure(error) {
  return {
    type: SYNC_INVOICE_FAILURE,
    error,
  };
}

export default {
  syncCartConfigurations,
  deleteCartConfiguration,
  deleteCartConfigurationSuccess,
  deleteCartConfigurationFailure,
  fetchCartConfigurations,
  fetchCartConfigurationsSuccess,
  fetchCartConfigurationsFailure,
  saveCartConfiguration,
  saveCartConfigurationSuccess,
  saveCartConfigurationFailure,
  syncEmbedConfigurations,
  deleteEmbedConfiguration,
  deleteEmbedConfigurationFailure,
  deleteEmbedConfigurationSuccess,
  saveEmbedConfiguration,
  saveEmbedConfigurationSuccess,
  saveEmbedConfigurationFailure,
  fetchEmbedConfigurations,
  fetchEmbedConfigurationsFailure,
  fetchEmbedConfigurationsSuccess,
  loadCustomers,
  createCustomer,
  updateCustomer,
  loadCompany,
  createCompany,
  updateCompany,
  updatePlan,
  authUserSuccess,
  authUserSet,
  docketShopValidationFailure,
  signOut,
  subscribe,
  subscribeSuccess,
  subscribeFailure,
  stripeConnect,
  stripeConnectSuccess,
  stripeConnectFailure,
  loadccGateway,
  loadPricingMatrices,
  loadccGatewaySuccess,
  loadccGatewayFailure,
  deleteCustomer,
  loadPayments,
  loadCompanyPlanSuccess,
  createDocument,
  createDocumentSuccess,
  createDocumentFailure,
  updateDocument,
  updateDocumentSuccess,
  updateDocumentFailure,
  deleteDocument,
  deleteDocumentSuccess,
  deleteDocumentFailure,
  loadDocuments,
  createDocumentInstance,
  createDocumentInstanceSuccess,
  createDocumentInstanceFailure,
  updateDocumentInstance,
  updateDocumentInstanceSuccess,
  updateDocumentInstanceFailure,
  deleteDocumentInstance,
  deleteDocumentInstanceSuccess,
  deleteDocumentInstanceFailure,
  shareDocumentInstance,
  loadDocumentInstances,
  updateUserConfigs,
  loadUserConfigs,
  loadUserConfigsSuccess,
  updateUserConfigsSuccess,
  loadUnassignedInvoicesSuccess,
  loadIntregrations,
  loadUnpaidInvoicesSuccess,
  loadCompanyMembers,
  loadCompanyMembersSuccess,
  updateCompanySuccess,
  QBSyncInvoices,
  QBSyncCustomers,
  updateUser,
  syncProducts,
  fetchProducts,
  fetchProductsSuccess,
  fetchProductsFailure,
  syncVariants,
  fetchVariants,
  fetchVariantsSuccess,
  fetchVariantsFailure,
  deleteProduct,
  deleteProductSuccess,
  deleteProductFailure,
  saveProduct,
  saveProductSuccess,
  saveProductFailure,
  saveVariant,
  saveVariantSuccess,
  saveVariantFailure,
  deleteVariant,
  deleteVariantSuccess,
  deleteVariantFailure,
  loadProfileSuccess,
  loadCompanySuccess,
  loadCompanyFailure,
  deleteWorkflow,
  deleteWorkflowSuccess,
  deleteWorkflowFailure,
  saveWorkflow,
  saveWorkflowSuccess,
  saveWorkflowFailure,
  syncWorkflows,
  fetchWorkflows,
  fetchWorkflowsSuccess,
  fetchWorkflowsFailure,
  syncConnectedAccounts,
  fetchConnectedCompanies,
  fetchConnectedAccountsSuccess,
  fetchConnectedAccountsFailure,
  fetchConnectedCompaniesSuccess,
  fetchConnectedCompaniesFailure,
  saveConnectedAccount,
  saveConnectedAccountSuccess,
  saveConnectedAccountFailure,
  removeConnectedAccount,
  removeConnectedAccountSuccess,
  removeConnectedAccountFailure,
  syncDiscounts,
  fetchDiscounts,
  fetchDiscountsSuccess,
  fetchDiscountsFailure,
  saveDiscount,
  saveDiscountSuccess,
  saveDiscountFailure,
  deleteDiscount,
  deleteDiscountSuccess,
  fetchApiKeys,
  fetchApiKeysSuccess,
  setMaxDailyBookableTasks,
  QBSyncFinished,
  loadReferrals,
  loadReferralsSuccess,
  loadReferralsFailure,
  syncInvoice,
  syncInvoiceSuccess,
  syncInvoiceFailure,
};
